import { __awaiter, __generator } from "tslib";
export var MediaManagerMediaType;
(function (MediaManagerMediaType) {
    MediaManagerMediaType["IMAGE"] = "IMAGE";
    MediaManagerMediaType["ALL_MEDIA"] = "ALL_MEDIA";
    MediaManagerMediaType["VIDEO"] = "VIDEO";
    MediaManagerMediaType["AUDIO"] = "MUSIC";
})(MediaManagerMediaType || (MediaManagerMediaType = {}));
var MediaManagerPanel = /** @class */ (function () {
    function MediaManagerPanel(mediaManagerInstance) {
        this.mediaManagerInstance = mediaManagerInstance;
    }
    MediaManagerPanel.prototype.open = function (_a) {
        var mediaType = _a.mediaType, isMultiSelect = _a.isMultiSelect, appDefId = _a.appDefId, onSuccess = _a.onSuccess;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!('editor' in this.mediaManagerInstance)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mediaManagerInstance.editor
                                .openMediaPanel('', {
                                mediaType: mediaType,
                                isMultiSelect: isMultiSelect,
                            })
                                .then(onSuccess)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.mediaManagerInstance.invoke('mediaManager.open', mediaType, appDefId || '', {
                            multiSelect: isMultiSelect,
                            onSuccess: function (data) { return onSuccess(data.items); },
                        });
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MediaManagerPanel;
}());
export { MediaManagerPanel };
//# sourceMappingURL=mediaManagerPanel.js.map